import axios from 'axios'

const BASE_URL = `${process.env.REACT_APP_DATA_LOGGER_BASE_URL}/v1`

export const uptimeService = async (params) => {
  console.log(params)
  try {
    const response = await axios.get(
      `${BASE_URL}/machine-metric/uptime-metric`,
      {
        params: params
      }
    )
    return response
  } catch (err) {
    console.log(err)
    return err.response
  }
}


export const breakdownDataService = async (params) => {
  console.log(params)
  try {
    const response = await axios.get(
      `${BASE_URL}/machine-metric/breakdown-data`,
      {
        params: params
      }
    )
    return response
  } catch (err) {
    console.log(err)
    return err.response
  }
}

export const getLastUpdatedDate = async (params) => {
  console.log(params)
  try {
    const response = await axios.get(
      `${BASE_URL}/maintenance-tracking/last-processed-date`,
      {
        params: params
      }
    )
    return response
  } catch (err) {
    console.log(err)
    return err.response
  }
}

export const getLatestData = async (params) => {
  console.log(params)
  try {
    const response = await axios.get(
      `${BASE_URL}/machine-metric/process-breakdown`,
      {
        params: params
      }
    )
    return response
  } catch (err) {
    console.log(err)
    return err.response
  }
}